/**
 * 表（docs/06 4-8）。
 *
 * 幅が足りないときは**横にずらして見る**形にする（列を勝手に隠さない）。
 * 中身（見出し行・本体）は使う側が書く。
 */
import type { ReactNode } from 'react';

export interface DataTableProps {
  /** 表全体が何の一覧かを読み上げに伝える言葉 */
  label?: string;
  /** 列が多い表は、狭い画面でもこの幅を保って横にずらして見る。 */
  minWidth?: string;
  children: ReactNode;
}

export function DataTable({ label, minWidth, children }: DataTableProps): ReactNode {
  return (
    // キーボードだけでも横にずらせるように、囲みそのものを選べるようにしておく
    <div
      className="admin-table-wrap"
      tabIndex={0}
      {...(label !== undefined ? { role: 'group', 'aria-label': label } : {})}
    >
      <table className="ui-table" style={minWidth === undefined ? undefined : { minWidth }}>
        {children}
      </table>
    </div>
  );
}
